import axios from "axios";
var csrfTokenElement = document.querySelector('meta[name="csrf-token"]');
var localApi = process.env.APP_ENV === "local";
var http = axios.create({
    baseURL: localApi ? process.env.APP_PRODUCTION_URL : process.env.APP_URL,
    timeout: 30000,
    headers: {
        "Content-type": "application/json",
    },
});
http.interceptors.request.use(function (config) {
    if (config.method === "post") {
        var csrfContent = csrfTokenElement
            ? csrfTokenElement.getAttribute("content")
            : "";
        config.headers["X-CSRF-Token"] = csrfContent;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
http.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        var _a = error.response, status_1 = _a.status, data = _a.data;
        var errorCodes = [429, 403, 500];
        if (errorCodes.includes(status_1)) {
            window.location.href = "/erro/".concat(status_1);
            return;
        }
        if (status_1 === 428) {
            window.location.href = "/email/".concat(data.loginId);
        }
    }
    return Promise.reject(error);
});
export default http;
